module.exports = __webpack_public_path__ + "static/white_wall-6cb0935c4be70dfb097384f40827fb32.png";